import { Component, OnInit, NgModule } from '@angular/core';
import { SharedService } from '../shared.service';
import { CreateSpace } from '../space.pipe';
import { NgbModalConfig, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-productDetail',
  templateUrl: './productDetail.component.html',
  styleUrls: ['./productDetail.component.scss']
})

export class ProductDetailComponent implements OnInit {

  closeResult = '';

  tabIndex;
  tabName;
  constructor(
    private sharedservice: SharedService, 
    config: NgbModalConfig, 
    private modalService: NgbModal,
    private router: Router,
    private activatedRoute: ActivatedRoute
    ) { 
    }

  revenueMaximizer = [
    {
      title: 'Flexible subscription offering to bundle just the right plan for your organization budget ',
    },
    {
      title: 'Responsive web application platform with rich feature modules to efficiently work on missing predictions',
    },
    {
      title: 'Powerful recommendation engine built on top of AI models assisted with rule engine to accurately identify anomalies',
    },
    {
      title: 'Inbuilt knowledge repository for data exploration and view lineages of past accounts and take quick decisions',
    },
    {
      title: 'Configurable modules to manage features efficiently by the administrator through web interface',
    },
    {
      title: 'Rich set of reports and dashboard for admin and supervisors to have holistic view of system performance',
    },
    {
      title: 'A flexible notification module to setup and manage business communication in the system',
    }
  ];

  studioedge = [
    {
      title: 'Highly scalable set of product modules to design, deploy and extract business insights in single integrated ecosystem',
    },
    {
      title: 'Rich set of data enrichment modules to identify data pattern, design parallel workflows for various use cases and develop end to end solution',
    },
    {
      title: 'Flexibility to build custom solutions from scratch or leverage existing AI enabled models to expedite development cycle',
    },
    {
      title: 'Version supported rich module repository to create a curated solution bundle aligned with your organizational needs',
    },
    {
      title: 'Rich dashboard to monitor solution insights in real-time and notify stakeholders for any alert when system identifies a threshold breach',
    },
    {
      title: 'Fully scaled integration capability with downstream systems to cater for business reporting consumptions or prepare further analytical models',
    }
  ];

  atlas = [
    { title: 'Design and orchestrate AI-powered business solutions through reusable agents, workflows and intelligent automation',},
    { title: 'Create semantic knowledge ontology connecting enterprise entities, relationships, policies, conditions, and business rules',},
    { title: 'Build curated RAG pipelines that combine trusted enterprise sources, semantic retrieval, and contextual filtering for grounded responses',},
    { title: 'Apply Enterprise Trust Ranking (ETR) and evidence attribution to prioritize reliable knowledge and improve response trustworthiness',},
    { title: 'Enable MCP-based tool connectivity for dynamic interaction with enterprise applications, APIs, data sources, and external services.',},
    { title: 'Validate AI agents and solutions through scenario-based testing and an interactive AI Playground before deployment',},
    { title: 'Govern the complete AI lifecycle through deployment management, versioning, observability, evaluation, compliance, and Responsible AI controls',},
  ]

  dataflow = [
    {
      title: 'Enable flexible data pipeline creation with set of industry standard activity configuration pages that can ingest, process and profile your organization spend data',
    },
    {
      title: 'A rich set of connectors integrating with various system to ingest and work on data',
    },
    {
      title: 'Offers elastic model selection capability to experiment and improve performance',
    },
    {
      title: 'Powerful monitoring tool to view, analyse and act on jobs output in real-time',
    },
    {
      title: 'Comprehensive dashboard view that helps in spend analysis, supplier performance evaluation and finding cost-saving opportunities',
    }
  ];


  resourcingVista = [
    {
      title: "Centralized Resource Management",
      para: "Streamlines staffing operations, eliminating manual workflows across accounts, projects, and teams"
    },
    {
      title: "Opportunity, Revenue & Margin Tracking",
      para: "Gain a comprehensive view of upcoming opportunities, resource demand, and financial metrics, including revenue and margins."
    },
    {
      title: "Real-Time Visibility & Utilization Tracking",
      para: "Offers instant insights into staff availability, project allocations, and resource performance."
    },
    {
      title: "Seamless Collaboration for Staffing Needs",
      para: "Connects Account Leads, Vertical Heads, and Staffing Managers to simplify staffing approvals and coordination"
    },
    {
      title: "Employee Self-Service Enablement",
      para: "Lets employees update skills, manage timesheets, and track leave for improved engagement and data accuracy."
    },
    {
      title: "Insightful Reporting & Forecasting",
      para: "Provides powerful utilization, pipeline, and financial reports to support operational and strategic planning."
    },
    {
      title: "Role-Based Dashboards",
      para: "Customized dashboards for executives, staffing managers, and employees to monitor KPIs and drive action."
    },
  ];

  inquery = function() {
    this.router.navigateByUrl('/contact');
  };
  open(content) {
    this.modalService.open(content, { windowClass : 'staffing-popup'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnInit() {
    const tabName = this.activatedRoute.snapshot.paramMap.get("tab");
    if(tabName) {
      this.tabName = tabName;
    }
    this.tabIndex = this.getTabIndex(tabName);
  }

  getTabIndex(tabName: string) {
    switch (tabName) {
      case "RevenueMaximizers":
        return 1
        break;
      case "ATLAS":
        return 2
        break;
      case "DataEdge":
        return 3
        break;
      case "SpendGenious":
        return 5
        break;
      case "ResourcingVista":
        return 4
        break;
      default:
        this.tabName = "RevenueMaximizers";
        return 1
        break;
    }
  }

  title(i) {
    if (i === 1) {
      this.tabName = 'RevenueMaximizers';
    } else if (i ===2) {
      this.tabName = 'ATLAS';
    } else if (i === 3) {
      this.tabName = 'DataEdge';
    } else if (i === 5) {
      this.tabName = 'SpendGenious';
    } else if (i === 4) {
      this.tabName = 'ResourcingVista';
    }
    this.router.navigate(["product-detail",this.tabName])
  }

  slideConfig = {
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 1500,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1
        }
      }
    ]
  };
  revenuemaximizerProd = [
    {title: ''},
    {title: ''},
    {title: ''},
    {title: ''},
    {title: ''},
    {title: ''}
  ];
  atlasProd = [
    {title: ''},
    {title: ''},
    {title: ''},
    {title: ''}
];
  studioedgeProd = [
    {title: ''},
    {title: ''},
    {title: ''},
    {title: ''},
    {title: ''},
    {title: ''}
  ];
  dataflowProd = [
    {title: ''},
    {title: ''},
    {title: ''},
    {title: ''},
    {title: ''},
    {title: ''}
  ];
  resourcingVistaProd = [
    {title: ''},
    {title: ''},
    {title: ''},
    {title: ''}
  ];
}
